export const LESSON_SEARCH_LIMIT = 10;

/**
 * Arguments for the lesson search behind the curriculum lesson field.
 *
 * `limit` is load-bearing, not cosmetic: /api/proxy/lessons only takes its
 * searchable SQL path when teacher_id, status, limit or offset is present, and
 * otherwise proxies to a legacy endpoint that ignores `search` outright.
 *
 * `status` is deliberately absent so unpublished lessons come back alongside
 * published ones; callers tell them apart by `is_published`.
 */
export const lessonSearchParams = (term: string) => ({
  search: term,
  limit: LESSON_SEARCH_LIMIT,
});
